export class DashboardAccordionIndexKey {
  public static readonly accordionIndex: string = 'accordionIndex';
}
